import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import router from '@/router'

const dsn = (process.env.VUE_APP_SENTRY_DSN || '').trim()

if (dsn) {
  Sentry.init({
    Vue,
    dsn,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.VUE_APP_RELEASE || process.env.npm_package_version,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
    ],
    tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
  })
}
